import { asyncHandler } from '../../async-handler';
import store from '../../../../store/store';
import { RequestInfo } from '../../../../interfaces/RequestInfo';
import { MANAGE_SUBSCRIPTION_API } from '../../../constants/central-api';

export default async function manage_package_subscriptions_api_call(
  subscriptionId: number
) {
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  const requestInfo: RequestInfo = {
    url: MANAGE_SUBSCRIPTION_API(subscriptionId.toString()),
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'MANAGE_SUBSCRIPTIONS';
  const customMsg = 'Manage Subscription successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data;

  if (res?.actionType === actionType && response?.success === true) {
    if (response?.data) {
      return response;
    }
  }
  return false;
}
